import Axios from 'axios'
import { AddressDTO } from 'src/viewModels/AddressDTO'
import { ProviderDto } from '../generated_client'
import { ClaimUpdateDueDateSummary } from '../viewModels/ClaimUpdateDueDateSummary'

const base_url = process.env.REACT_APP_BASE_URL || 'http://localhost:5000'

export async function UpdateAllLocationBillingAddresses(
  providerId: string | undefined,
  billingAddress: AddressDTO
) {
  const response = await Axios.put(
    `${base_url}/api/provider/${providerId}/location-billing-addresses`,
    billingAddress
  )
  return response
}

export async function CreateProvider(provider: ProviderDto) {
  const response = await Axios.post(`${base_url}/api/provider`, provider)
  return response.data
}

export async function UpdateProvider(
  providerId: string | undefined,
  provider: ProviderDto
): Promise<ClaimUpdateDueDateSummary> {
  const response = await Axios.put(`${base_url}/api/provider/${providerId}`, provider)
  return response.data
}
